import React, { useState } from 'react';
import { Lock, ShieldAlert } from 'lucide-react';
import { Button } from '../Button';
import { Input } from '../Input';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../Card';
interface InternalGateProps {
  onUnlock: (passcode: string) => boolean;
}
export function InternalGate({
  onUnlock
}: InternalGateProps) {
  const [passcode, setPasscode] = useState('');
  const [error, setError] = useState<string | null>(null);
  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    const granted = onUnlock(passcode);
    if (!granted) {
      setError('That passcode is not recognized. Access attempts are logged.');
      setPasscode('');
      return;
    }
    setError(null);
  };
  return <main className="flex min-h-[100dvh] w-full items-center justify-center bg-background px-5 py-12 sm:px-6" data-id="element-106" data-mp="1w26gznl4altj">
      <Card className="w-full max-w-sm" data-id="element-107" data-mp="3vatmxzfpuf7w">
        <CardHeader data-id="element-108" data-mp="3qf619u0g0475">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-secondary text-secondary-foreground" data-id="element-109" data-mp="3qemg84fhwzow">
            <Lock className="h-4 w-4" aria-hidden="true" data-id="element-110" data-mp="1z5sxv0w0tnmc" />
          </span>
          <CardTitle className="mt-3" data-id="element-111" data-mp="244dz93n0edcd">Internal access only</CardTitle>
          <CardDescription data-id="element-112" data-mp="1p6btcmsi9fry">
            Traffic telemetry for the maintenance window. Turing staff only.
          </CardDescription>
        </CardHeader>
        <CardContent data-id="element-113" data-mp="1u6psffc4pfdu">
          <form onSubmit={handleSubmit} className="flex flex-col gap-3" noValidate data-id="element-114" data-mp="2huhe39jk74rs">
            <label htmlFor="passcode" className="text-sm font-medium text-foreground" data-id="element-115" data-mp="2hwk43tkpoxwi">
              Operator passcode
            </label>
            <Input id="passcode" type="password" autoComplete="off" autoFocus value={passcode} placeholder="••••••••" aria-invalid={error ? true : undefined} aria-describedby={error ? 'passcode-error' : undefined} onChange={event => {
            setPasscode(event.target.value);
            setError(null);
          }} data-id="element-116" data-mp="28567btk5ac72" />
            {error && <p id="passcode-error" role="alert" className="flex items-start gap-2 text-xs text-destructive" data-id="element-117" data-mp="3agfte9y3ua1m">
                <ShieldAlert className="mt-px h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-118" data-mp="31g9i8upvpm5m" />
                {error}
              </p>}
            <Button type="submit" size="lg" className="mt-1 w-full" disabled={!passcode} data-id="element-119" data-mp="2whog2pr2gsej">
              Unlock dashboard
            </Button>
          </form>
        </CardContent>
      </Card>
    </main>;
}